import { connect } from 'react-redux'

import SiteMeta from './siteMeta'

import { Site } from '../../../../common/constants/siteList'
import { IRootState } from '../../../../common/reducers'

interface IOwnProps {
  seoMeta: any
  location: any
  currentSite: Site
  noIndex: boolean
  baseUrl: string
  canonicalPath: string
}

interface IStateProps {
  menuConfig: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common: { menuConfig } } = state

  return { menuConfig }
}

const SiteMetaContainer = connect<IStateProps, {}, IOwnProps, IRootState>(
  mapStateToProps
)(SiteMeta)

export default SiteMetaContainer
